let selected_worker = [];
export default {
    init() {
        this.showModalAddEmployee();
        this.initPagerTextarea();
        this.initCheckbox();
        this.initAddButton();
        this.initRemoveWorker();
        this.initSendPager();
        this.checkSendPager();
    },
    showModalAddEmployee() {
        let $this = this;
        $('#add-employee-btn').on('click', function (e) {
            e.preventDefault()
            let workers = $('.workers .worker');
            workers.each(function () {
                let worker = $(this);
                if ($.inArray(worker.val(), selected_worker) >= 0) {
                    worker.prop('checked', true);
                } else {
                    worker.prop('checked', false);
                }
            });
            $this.checkAddAll();
            $('#add-employee-modal').modal('show');
        });
    },
    initPagerTextarea() {
        let $this = this;
        let pager = $('#pager-message');
        pager.on('focus', function (e) {
            e.preventDefault();
            if (pager.val() === 'Type text') {
                pager.val('');
            }
        });
        pager.on('focusout', function (e) {
            e.preventDefault();
            if (pager.val() === '') {
                pager.val('Type text');
            }
            $this.checkSendPager();
        });
    },
    initCheckbox() {
        let $this = this;
        $('body').on('click', '#add-employee-modal #add-all', function () {
            let workers = $('.workers .worker');
            if ($('body #add-all').is(':checked')) {
                workers.each(function () {
                    let worker = $(this);
                    worker.prop('checked', true);
                });
            } else {
                workers.each(function () {
                    let worker = $(this);
                    worker.prop('checked', false);
                });
            }
        });
        $('body').on('click', '#add-employee-modal .workers .worker', function () {
            $this.checkAddAll();
        });
    },
    initAddButton() {
        let $this = this;
        $('body').on('click', '#add-employee-modal .add-workers', function (e) {
            e.preventDefault();
            selected_worker = [];
            let selected_worker_label = [];
            let workers = $('.workers .worker');
            let pager_workers = $('.pager-workers');
            let workers_info = '';
            workers.each(function () {
                let worker = $(this);
                if (worker.is(':checked')) {
                    selected_worker.push(worker.val());
                    let label = $('.workers label[for="phone-worker-' + worker.val() + '"]').text();
                    selected_worker_label.push([worker.val(), label]);
                }
            });
            selected_worker_label.forEach(function (item) {
                workers_info += '<div class="worker"><span>' + item[1] + '</span><i data-id="' + item[0] +
                    '" class="fa fa-lg fa-close-grey remove-worker"></i></div>';
            });
            pager_workers.html(workers_info);
            $this.checkSendPager();
            $('#add-employee-modal').modal('hide');
        });
    },
    initRemoveWorker() {
        let $this = this;
        $('body').on('click', '#pager .remove-worker', function () {
            for(let i = 0; i < selected_worker.length; i++) {
                if (parseInt(selected_worker[i]) === parseInt($(this).data('id'))) {
                    selected_worker.splice(i, 1);
                    i--;
                }
            }
            $(this).closest('.worker').remove();
            $this.checkSendPager();
        });
    },
    initSendPager() {
        let $this = this;
        $('#pager form').on('submit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/pager',
                data: ({
                    phones: selected_worker,
                    text: $('#pager #pager-message').val(),
                }),
                success: function () {
                    selected_worker = [];
                    $('#pager .pager-workers').html('');
                    $('#pager #pager-message').val('Type text');
                    $this.checkSendPager();
                }
            });
        });
    },
    checkAddAll() {
        let workers = $('body .workers .worker');
        let add_all = $('body .workers #add-all');
        let all_checked = true;
        workers.each(function () {
            let worker = $(this);
            if (!(worker.is(':checked'))) {
                all_checked = false;
            }
        });
        if (all_checked) {
            add_all.prop('checked', true);
        } else {
            add_all.prop('checked', false);
        }
    },
    checkSendPager() {
        if (selected_worker.length) {
            if ($('#pager #pager-message').val() !== 'Type text') {
                $('#pager form .send-pager').prop('disabled', false);
            } else {
                $('#pager form .send-pager').prop('disabled', true);
            }
        } else {
            $('#pager form .send-pager').prop('disabled', true);
        }
    }
}
